import React, { memo } from 'react';

import { Box } from '@mui/material';
import TextField from '@sharedCR/coreDesignSystem/form/TextFieldCDS';
import PropTypes from 'prop-types';

import LabelWithTooltip from '../LabelWithTooltip';

import { wrapperStyles } from './SequenceFormatPreview.styles';
import { getSequenceFormatPreview } from './SequenceFormatPreview.utils';

const PREVIEW_TOOLTIP =
  'Example of the first value this sequence will generate. Each run increases it by one.';

const SequenceFormatPreview = ({ digitCount, seed, name }) => (
  <Box sx={wrapperStyles}>
    <TextField
      disabled
      className="w-256"
      dataTestId={name}
      label={<LabelWithTooltip description={PREVIEW_TOOLTIP} label="Generated Format" />}
      name={name}
      placeholder="e.g. 000123"
      value={getSequenceFormatPreview({ digitCount, seed })}
      variant="outlined"
    />
  </Box>
);

SequenceFormatPreview.propTypes = {
  name: PropTypes.string.isRequired,
  digitCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  seed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(SequenceFormatPreview);
